<sharry-header></sharry-header>
<div class="faq">
  <div class="faq__hero">
    <small class="faq__hero__tag bold">{{ 'faq.tag' | i18next }}</small>
    <h1 class="faq__hero__title bold">{{ 'faq.title' | i18next }}</h1>
    <mat-form-field appearance="outline">
      <input
        #search
        matInput
        type="text"
        [placeholder]="'faq.placeholder' | i18next"
        (input)="onSearch(search.value)" />
      <sharry-icon
        matPrefix
        registryName="magnifying-glass"
        svgClass="svg-icon--active"></sharry-icon>
      <sharry-icon
        matSuffix
        name="x-circle-fill"
        type="phosphor"
        svgClass="svg-icon"
        [class.hidden]="!search.value.length"
        (click)="onClearValue(search)"></sharry-icon>
    </mat-form-field>
    <p class="faq__hero__breadcrumbs">
      <a
        [routerLink]="['faq' | routeTranslate]"
        [routerLinkActive]="'active'"
        >{{ 'faq.back-to' | i18next }}&nbsp;{{ 'faq.back-to.link' | i18next }}</a
      >
      @if (faqService?.area || faqService?.section) {
        /
        <a
          [routerLink]="[faqService?.area | slug]"
          [routerLinkActive]="'active'"
          >{{ faqService?.area?.title }}</a
        >
      }
      @if (faqService?.section) {
        /
        <a
          [routerLink]="[faqService?.section | slug]"
          [routerLinkActive]="'active'"
          >{{ faqService?.section.title }}</a
        >
      }
    </p>
  </div>
  @if (isSearch) {
    <sharry-faq-search
      [faqBodies]="faqBodies$ | async"
      (back)="onClearValue(search)"></sharry-faq-search>
  }
  <router-outlet></router-outlet>
  <section>
    <div class="faq__contacts">
      <div class="faq__contacts__text">
        <small class="faq__hero__tag--smaller bold">{{ 'faq.contacts.tag' | i18next }}</small>
        <h2 class="faq__hero__title bold">{{ 'faq.contacts.title' | i18next }}</h2>
        <p class="bigger">{{ 'faq.contacts.text' | i18next }}</p>
        <a
          mat-flat-button
          color="primary"
          class="sharry-medium rounded"
          href="https://info.sharry.land"
          target="_blank"
          >{{ 'faq.contacts.button' | i18next }}</a
        >
      </div>
      <div
        lazybg
        class="faq__contacts__image"></div>
    </div>
  </section>
  @if (isMobile()) {
    <sharry-bottom-links></sharry-bottom-links>
  }
</div>

<sharry-footer class="is-not-mobile"></sharry-footer>
